/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Set default grid to 2 columns on mobile - 2025/11/11
  let isMobileView = window.innerWidth <= 767;

  function setMobileDefaultGrid(isResize = false) {
    const isCurrentlyMobile = window.innerWidth <= 767;

    // Only proceed if we're in mobile view
    if (isCurrentlyMobile) {
      const gridContainer = document.querySelector('.js-grid[data-grid-small]');
      const toggle2Button = document.querySelector('[data-toggle-grid="2"]');
      const allToggleButtons = document.querySelectorAll('[data-toggle-grid]');

      if (gridContainer && toggle2Button) {
        // For resize, check if we just transitioned to mobile
        if (isResize) {
          // Only auto-switch if we just transitioned from desktop to mobile
          if (!isMobileView && isCurrentlyMobile) {
            setTimeout(() => {
              // Remove active class from all buttons first
              allToggleButtons.forEach(btn => {
                btn.classList.remove('is-active');
              });

              // Trigger click on 2-column button
              toggle2Button.click();

              // Ensure 2-column button has active class
              setTimeout(() => {
                toggle2Button.classList.add('is-active');
              }, 50);
            }, 100);
          }
        } else {
          // Initial load
          setTimeout(() => {
            // Remove active class from all buttons first
            allToggleButtons.forEach(btn => {
              btn.classList.remove('is-active');
            });

            // Trigger click on 2-column button
            toggle2Button.click();

            // Ensure 2-column button has active class
            setTimeout(() => {
              toggle2Button.classList.add('is-active');
            }, 50);
          }, 150);
        }
      }
    }

    // Update state
    isMobileView = isCurrentlyMobile;
  }

  // Ensure filter is closed on mobile on initial load - 2025/11/11
  function ensureFilterClosedOnMobile() {
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      const filterWrapper = document.querySelector('.collection__filters__wrapper');

      if (filterWrapper) {
        // Remove drawer--visible class if present
        filterWrapper.classList.remove('drawer--visible');

        // Remove filters--default-visible class on mobile
        filterWrapper.classList.remove('filters--default-visible');
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setMobileDefaultGrid(false);
      ensureFilterClosedOnMobile();
    });
  } else {
    setMobileDefaultGrid(false);
    ensureFilterClosedOnMobile();
  }

  // Close filter drawer when resizing to mobile - 2025/11/11
  function closeFilterOnMobileResize() {
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      const filterWrapper = document.querySelector('.collection__filters__wrapper');
      const filterToggle = document.querySelector('[data-filters-toggle="filters"]');

      if (filterWrapper) {
        // Remove default visible class on mobile
        filterWrapper.classList.remove('filters--default-visible');

        // Close the drawer if it's open
        if (filterWrapper.classList.contains('drawer--visible')) {
          if (filterToggle) {
            filterToggle.click();
          }
        }
      }
    }
  }

  // Reset grid when transitioning from mobile to desktop - 2025/11/12
  function resetGridOnDesktopResize() {
    const isDesktop = window.innerWidth > 767;

    if (isDesktop && isMobileView) {
      // Transitioning from mobile to desktop
      const gridContainer = document.querySelector('.js-grid[data-grid-small]');
      const toggle3Button = document.querySelector('[data-toggle-grid="3"]');
      const allToggleButtons = document.querySelectorAll('[data-toggle-grid]');

      if (gridContainer && toggle3Button) {
        setTimeout(() => {
          // Force set grid to 3 columns by updating the data attribute
          gridContainer.setAttribute('data-grid-large', '3');

          // Remove active class from all buttons
          allToggleButtons.forEach(btn => {
            btn.classList.remove('is-active');
          });

          // Click the 3-column button
          toggle3Button.click();

          // Ensure 3-column button has active class
          setTimeout(() => {
            toggle3Button.classList.add('is-active');
          }, 50);
        }, 100);
      }
    }
  }

  // Prevent hamburger menu and filter drawer from auto-opening during resize - 2025/11/12
  let isResizing = false;
  let resizeTimer = null;
  let hamburgerWasOpen = false;
  let filterWasOpen = false;
  let savedFilterTransform = '';
  let savedFilterVisibility = '';

  // Initialize drawer observer immediately on page load
  function initializeDrawerProtection() {
    const hamburgerDrawer = document.querySelector('[data-drawer="hamburger"]');
    const filterDrawer = document.querySelector('.collection__filters__wrapper');

    if (!hamburgerDrawer && !filterDrawer) {
      // Retry after DOM is fully loaded
      setTimeout(initializeDrawerProtection, 100);
      return;
    }

    // Set up MutationObserver to watch hamburger drawer state
    if (hamburgerDrawer) {
      const hamburgerObserver = new MutationObserver((mutations) => {
        if (!isResizing) return;

        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            const hasVisible = target.classList.contains('drawer--visible');

            // If drawer state changed during resize, revert it immediately
            if (hasVisible !== hamburgerWasOpen) {
              if (hamburgerWasOpen) {
                target.classList.add('drawer--visible');
              } else {
                target.classList.remove('drawer--visible');
              }
            }
          }
        });
      });

      hamburgerObserver.observe(hamburgerDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Set up MutationObserver to watch filter drawer state
    if (filterDrawer) {
      const filterObserver = new MutationObserver((mutations) => {
        if (!isResizing) return;

        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            const hasVisible = target.classList.contains('drawer--visible');

            // If drawer state changed during resize, revert it immediately
            if (hasVisible !== filterWasOpen) {
              if (filterWasOpen) {
                target.classList.add('drawer--visible');
              } else {
                target.classList.remove('drawer--visible');
              }

              // Force the saved styles
              if (savedFilterTransform) {
                target.style.transform = savedFilterTransform;
              }
              if (savedFilterVisibility) {
                target.style.visibility = savedFilterVisibility;
              }
            }
          }
        });
      });

      filterObserver.observe(filterDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function startResizeProtection() {
    const hamburgerDrawer = document.querySelector('[data-drawer="hamburger"]');
    const filterDrawer = document.querySelector('.collection__filters__wrapper');

    // Remember current drawer states
    if (hamburgerDrawer) {
      hamburgerWasOpen = hamburgerDrawer.classList.contains('drawer--visible');
    }
    if (filterDrawer) {
      filterWasOpen = filterDrawer.classList.contains('drawer--visible');

      // Save current inline styles
      savedFilterTransform = filterDrawer.style.transform || '';
      savedFilterVisibility = filterDrawer.style.visibility || '';

      // Lock the current state with inline styles during resize
      if (!filterWasOpen) {
        filterDrawer.style.setProperty('transform', 'translateX(-100%)', 'important');
        filterDrawer.style.setProperty('visibility', 'hidden', 'important');
      }
    }

    isResizing = true;

    // Clear any existing timer
    clearTimeout(resizeTimer);

    // End resize protection after resize stops
    resizeTimer = setTimeout(() => {
      isResizing = false;

      // Remove inline styles when resize ends
      if (filterDrawer) {
        filterDrawer.style.removeProperty('transform');
        filterDrawer.style.removeProperty('visibility');
      }
    }, 500);
  }

  // Initialize protection when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDrawerProtection);
  } else {
    initializeDrawerProtection();
  }

  // Listen to resize events
  window.addEventListener('resize', startResizeProtection, { passive: true });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => {
    console.log(e);
    setMobileDefaultGrid(true);
    closeFilterOnMobileResize();
    resetGridOnDesktopResize();
  });

  // Open the full EU GARAN label when the label is clicked - 2026/09/17
  document.addEventListener('click', function(event) {
    var openButton = event.target.closest('[data-garan-open]');
    if (openButton) {
      var dialog = openButton.parentElement.querySelector('[data-garan-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    var closeButton = event.target.closest('[data-garan-close]');
    if (closeButton) {
      closeButton.closest('[data-garan-dialog]').close();
      return;
    }

    // Clicking the backdrop targets the dialog element itself
    if (event.target.matches('[data-garan-dialog]')) {
      event.target.close();
    }
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
